<template>
	<div>
		<div class="row mb-4">
			<div class="col-9">
				<div class="row pull-right">
					<div class="col-6">
						<Datepicker input-class="form-control form-control-sm" v-model="filter.start_date" name="start_date" placeholder="Start date"></Datepicker>
					</div>
					<div class="col-6">
						<Datepicker input-class="form-control form-control-sm" v-model="filter.end_date" name="end_date" @selected="$emit('change-zone-period', {period, filter, type: 'date'})" placeholder="End date"></Datepicker>
					</div>
				</div>
			</div>
			<div class="col-3">
				<div class="float-right">
					<div class="form-group">
						<select class="form-control-sm" id="period" v-model="period" @change="$emit('change-zone-period', {period, filter, type: 'period'})">
							<option value="-1440">Last 24 hours</option>
							<option value="-10080">Last week</option>
							<option value="-43200">Last 30 days</option>
						</select>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-4 text-center border-right">
				<h5>Total Threats</h5>
				<div class="h5 font-weight-bold">{{statistic.total | formatNumber}}</div>
			</div>
			<div class="col-4 text-center border-right">
				<h5>Top Country</h5>
				<div class="h5 font-weight-bold">{{statistic.top_country }}</div>
			</div>
			<div class="col-4 text-center">
				<h5>Top Threat Type</h5>
				<div class="h5 font-weight-bold">Bad browser</div>
			</div>
		</div>
		<div class="row mt-4">
			<div class="col-12">
				<canvas id="threatsChart" style="width: 100% !important;height: auto !important;"></canvas>
			</div>
		</div>
		<div class="row mt-4">
			<div>
				<h5>
					Top Traffic Countries / Regions
				</h5>
			</div>

			<div class="table-responsive mt-4" style="height: 300px; overflow: auto;">
				<table class="table">
					<thead>
					<tr class="table-active">
						<th scope="col">Country / Region</th>
						<th scope="col">Traffic</th>
					</tr>
					</thead>
					<tbody>
					<tr v-for="country in statistic.countries" :key="country.name">
						<th scope="row">{{country.name}}</th>
						<td>{{country.value | formatNumber}}</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>


<script>
	import moment from 'moment';
	import Chart from 'chart.js';
	import _ from 'lodash';
	import Datepicker from 'vuejs-datepicker';

	export default {
		name: "Threats",
		props: ["data", "countryList", "periodZone", "filter"],
		data: function () {
			return {
				statistic: {
					total: 0,
					top_country: '',
					countries: [],
					bots: [],
					period: ''
				},
        chart: null
			}
		},
		components: {
			Datepicker
		},
		watch: {
			periodZone: {
				immediate: true,
				deep: true,
				handler(value) {
					this.period = value;
				}
			},
			data: function (data) {
				this.statistic.total = data.totalThreats;
        let countries = data.countryMap;
        countries = _.mapValues(countries, (item) => {
          let country = _.filter(this.countryList, (country) => {
            return country.alpha2Code == item.clientCountryName;
          });
          return {
            name: country.length > 0 ? country[0].name : item.clientCountryName,
            value: parseInt(item.threats)
          };
        });
				this.statistic.countries = _.reverse(_.sortBy(countries, ['value']));
				if (this.statistic.countries.length) {
					this.statistic.top_country = this.statistic.countries[0].name;
				}

				let ctx = document.getElementById('threatsChart');
        if (this.chart) {
          this.chart.destroy();
        }
        this.chart = new Chart(ctx, {
					type: 'line',
					data: {
						datasets: [
							{
								label: 'Bad browser',
								borderColor: '#ef8157',
								backgroundColor: 'transparent',
								borderWidth: 1,
								showLine: true,
								data: data.threats
							}
						]
					},
					options: {
						scales: {
							xAxes: [{
								type: 'time',
								distribution: 'series',
								time: {
									parser: 'MM/DD/YYYY',
									unit: 'day',
									displayFormats: {
										quarter: 'MM/DD/YYYY'
									},
									stepSize: 50
								},
								ticks: {
									source: 'data',
									autoSkip: true
								},
								scaleLabel: {
									display: true,
									labelString: 'Time (local)'
								}
							}],
							yAxes: [{
								scaleLabel: {
									display: true,
									labelString: 'Number of Requests'
								}
							}]
						}
					}
				});
			}
		}
	};
</script>
